import { useQuery } from "react-apollo"
import { GET_DEPENDENCIES } from "../queries"
import { GatsbyDependency } from "@modules/graphql/types"

export function useSiteDependencies(siteId: string) {
  const { loading, data, error } = useQuery(GET_DEPENDENCIES, {
    variables: { siteId },
  })

  const siteDependencies: Array<GatsbyDependency> =
    data?.gatsbyDependenciesForSite || []

  return { siteDependencies, loading, error }
}
